import { render, staticRenderFns } from "./ReceiveDetail.vue?vue&type=template&id=a9185d28"
import script from "./ReceiveDetail.vue?vue&type=script&lang=js"
export * from "./ReceiveDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports